module.exports = __webpack_public_path__ + "static/media/shaz_macavoy.fcc34d02.jpg";